import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "../AdminMenu";
import AdminHeader from "../AdminHeader";
import axios from "axios";
import ReactPaginate from "react-paginate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import { ADMIN_API_BASE } from "../../../utils/apiConfig";
import ConfirmModal from "../../../components/modal/ConfirmModal";

const AdminBlogPosts = () => {
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [blogs, setBlogs] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [blogIdToDelete, setBlogIdToDelete] = useState(null);
    const itemsPerPage = 32;

    const getCsrfToken = async () => {
        try {
            const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            return data.csrfToken;
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
            return null;
        }
    };

    useEffect(() => {
        const fetchBlogs = async () => {
            const token = await getCsrfToken();
            try {
                const response = await axios.get(`${ADMIN_API_BASE}/blog`, {
                    withCredentials: true,
                    headers: {
                        'csrf-token': token,
                    },
                });

                if (response.data.data !== null) {
                    setBlogs(response.data.data);
                    setFilteredBlogs(response.data.data);
                }

            } catch (error) {
                console.error('There was a problem with the axios request:', error);
            }
        };

        fetchBlogs();
    }, []);

    useEffect(() => {
        if (blogs != null && blogs.length > 0) {
            let sortedBlogs = [...blogs];
            setFilteredBlogs(sortedBlogs);
            setCurrentPage(0);
        }
    }, [blogs]);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleDeleteClick = (blogId) => {
        setBlogIdToDelete(blogId);
        setIsModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        if (!blogIdToDelete) return;

        try {
            const token = await getCsrfToken();
            await axios.delete(`${ADMIN_API_BASE}/blog/${blogIdToDelete}`, {
                withCredentials: true,
                headers: {
                    'csrf-token': token,
                },
            });
            setBlogs(blogs.filter(blog => blog.id !== blogIdToDelete));
            setFilteredBlogs(filteredBlogs.filter(blog => blog.id !== blogIdToDelete));
            alert('مقاله با موفقیت حذف شد.');
        } catch (error) {
            console.error('Error deleting blog post:', error);
            alert('خطایی در حذف مقاله رخ داد.');
        } finally {
            setIsModalOpen(false);
            setBlogIdToDelete(null);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setBlogIdToDelete(null);
    };

    const offset = currentPage * itemsPerPage;
    const currentBlogs = filteredBlogs && filteredBlogs.length > 0 && filteredBlogs.slice(offset, offset + itemsPerPage);

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='مقاله ها'/>
                        <div className='w-full flex gap-4 py-3 px-10 flex-1 my-10'>
                            {currentBlogs && currentBlogs.length > 0 && currentBlogs.map(blog => (
                                <div key={blog.id} className="w-1/4">
                                    <Link to={`/admin/blog/edit/${blog.id}`} className="block">
                                        <div
                                            className="bg-white p-5 shadow-md rounded-sm transition hover:bg-gray-100 hover:-translate-y-2">
                                            <h2 className="text-md line-clamp-2 mb-5">{blog.title}</h2>
                                            <span className="text-sm text-gray-700">{blog.category}</span><br />
                                            <span className="text-sm text-gray-700">{blog.updated_at}</span><br />
                                            <span className="text-sm text-blue-600 block mt-5">{blog.status ? 'منتشر شده' : 'پیش نویس'}</span>
                                        </div>
                                    </Link>
                                    <button
                                        className="bg-red-400 rounded-sm px-3 py-2 mt-2"
                                        onClick={() => handleDeleteClick(blog.id)}
                                    >
                                        حذف
                                    </button>
                                </div>
                            ))}
                        </div>
                        <ReactPaginate
                            previousLabel={'قبلی'}
                            nextLabel={'بعدی'}
                            breakLabel={'...'}
                            pageCount={filteredBlogs && filteredBlogs.length > 0 && Math.ceil(filteredBlogs.length / itemsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination flex justify-center mt-4'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link p-2 border rounded mx-1'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link p-2 border rounded mx-1'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link p-2 border rounded mx-1'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link p-2 border rounded mx-1'}
                        />
                    </div>
                </div>
            </div>
            <ConfirmModal open={isModalOpen} onConfirm={handleDeleteConfirm} onCancel={handleModalClose} message="آیا مطمئن هستید که می‌خواهید این مقاله را حذف کنید؟"  />
        </>
    );
};

export default AdminBlogPosts;